import { useRouter } from 'next/router'
import ViewTracker from '../../../../components/tracking/view-tracker'
import { H6 } from '../../../../styles/typography'
import { DescriptionEl } from '../elements'
import CourseHomeStore from '../stores/course-home-store'

const Description = () => {
  const { asPath } = useRouter()
  const {
    data: { description },
  } = CourseHomeStore.useContainer()

  return (
    <DescriptionEl>
      <ViewTracker page={asPath} item='description' />

      <H6 className='title'>Course Description</H6>
      <div
        className='description'
        /* eslint-disable-next-line react/no-danger */
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </DescriptionEl>
  )
}

export default Description
